import { http, HttpResponse } from 'msw';

const handlers = [
  http.get('/api/kubernetes/clusters/:clusterId/cost-history', () => {
    return HttpResponse.json({});
  }),
  http.get('/api/kubernetes/clusters/:clusterId/problematic-workloads', () => {
    return HttpResponse.json({});
  }),
  http.get('/api/kubernetes/clusters/:clusterId/rebalanced-workloads', () => {
    return HttpResponse.json({});
  }),
  http.get('/api/kubernetes/clusters/:clusterId/rebalancing-plans', () => {
    return HttpResponse.json({});
  }),
  http.get('/api/kubernetes/clusters/:clusterId/workloads', () => {
    return HttpResponse.json({});
  }),
];

export default handlers;
